<template>
  <div>

    <a-tabs defaultActiveKey="1" class="air-tabs-bordered" @change="tabSwitch">
      <a-tab-pane tab="Kortingen" key="1">
        <button
          type="button"
          @click="openCreateDiscountModal()"
          class="btn btn-primary btn-with-addon mr-auto text-nowrap d-none d-md-block"
        >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
          Nieuwe Korting
        </button>
        <div v-if="discountLoading"  class="w-100 d-flex justify-content-center align-items-center">
          <a-spin size="large" />
        </div>
        <a-table
        v-else
          :columns="discountColumns"
          :dataSource="discounts"
          :pagination="false"
          :rowKey='data=>{return `discount-${data.id}`}'
        >
          <!--        <template slot="avatar" slot-scope="link">-->
          <!--          <div class="air__utils__avatar">-->
          <!--            <img :src="link" alt="User" />-->
          <!--          </div>-->
          <!--        </template>-->
          <template slot="service_name"  slot-scope="data">
            <div>
              <div>{{data.services ? data.services.name: 'Prijskorting'}}</div>
            </div>
          </template>
          <template slot="prijs" slot-scope="data">
            <div>
              <div>{{data.discounted_rate !== "" ? '€ ':''}}<s>{{data.services ? data.services.rate : ""}}</s> {{data.discounted_rate}}</div>
            </div>
          </template>
          <template slot="korting_hoeveelheid" slot-scope="data">
            <div>
              <div>{{data.discount_type === 'rate'? `€${data.discount_amount}`:`${data.discount_amount}%`}}</div>
            </div>
          </template>
          <template slot="action" slot-scope="data">
            <div>
              <button type="button" class="btn btn-primary mr-2">
                <i class="fe fe-plus-circle" />
              </button>
              <button type="button" @click="openUpdateDiscountModal(data)" class="btn btn-light">
                <i class="fe fe-edit text-blue" />
              </button>
            </div>
          </template>
        </a-table>
        <a-modal
            id="modal-1"
            title="Korting aanmaken"
            v-model="createDiscountModal"
            @ok="createDiscount()"
          >
            <a-form layout="inline">
              <a-form-item label="Kortingstype">
                <a-dropdown>
                  <a-menu slot="overlay" @click="handleDiscountTypeMenuClick">
                    <a-menu-item key="rate"> <a-icon type="euro" />Bedrag</a-menu-item>
                    <a-menu-item key="percentage"> <a-icon type="percentage" />Percentage</a-menu-item>
                  </a-menu>
                  <a-button style="margin-left: 8px"> {{discountTypeLabel}} <a-icon type="down" /> </a-button>
                </a-dropdown>
              </a-form-item>

              <a-form-item :label="(createDiscountDiscountType === 'percentage') ? 'Kortingspercentage' : 'Kortingsbedrag'">
                <a-input :placeholder="discountTypeLabel" v-model="newDiscountAmount"/>
              </a-form-item>
              <br />
              <a-form-item label="Globaal">
                <a-checkbox placeholder="" v-model="newDiscountGlobal"></a-checkbox>
              </a-form-item>
              <br />
              <a-form-item label="Voor een service?">
                <a-checkbox placeholder="" v-model="newDiscountForService" @change="toggleDiscountForService"></a-checkbox> <!-- create watcher for this to load in services -->
              </a-form-item>
              <a-form-item v-if="newDiscountForService">
                <div v-if="discountServicesListLoading"  class="">
              <a-spin size="large" />
            </div>
            <div>
              <a-dropdown>
              <a-menu slot="overlay" @click="handleDiscountForServiceMenuClick">
                    <a-menu-item v-for="service in discountServicesList" :key="`${service.id}`">{{service.name}} €{{service.rate}}</a-menu-item>
                </a-menu>
                <a-button :key="newDiscountForServiceSelectedLabel" v-if="(typeof newDiscountForServiceSelectedLabel === 'object')" style="margin-left: 8px"> {{newDiscountForServiceSelectedLabel.name}} €{{newDiscountForServiceSelectedLabel.rate}} <a-icon type="down" />  </a-button>
                <a-button v-else style="margin-left: 8px"> Selecteer een service <a-icon type="down" />  </a-button>
              </a-dropdown>
            </div>
              </a-form-item>
              <!--            <a-form-item> TODO expiration date -->
              <!--              <a-input placeholder="8 Digit Pin" addonBefore="$" />-->
              <!--            </a-form-item>-->
              <b-toast id="code-empty" variant="danger" title="Kortingscode">
                <i class="fe fe-alert-octagon mr-2" />Code kan niet leeg zijn
              </b-toast>
              <b-toast id="code-created" variant="primary" title="Kortingscode" >
                <i class="fe fe-plus-circle mr-2" />Code aangemaakt
              </b-toast>
              <b-toast id="something-went-wrong" variant="danger" title="Kortingscode">
                <i class="fe fe-alert-octagon mr-2" />Er ging iets fout
              </b-toast>
              <b-toast id="code-exists" variant="danger" title="Kortingscode" >
                <i class="fe fe-alert-octagon mr-2" />Code bestaat al
              </b-toast>
            </a-form>
          </a-modal>
          <a-modal
            id="modal-1"
            title="Kortingscode aanmaken"
            v-model="updateDiscountModal"
            @ok="updateDiscount()"
          >
            <a-form layout="inline">
              <a-form-item Label="Kortingscode">
                <a-input placeholder="Code" v-model="newDiscountCode"/>
              </a-form-item>
              <!--            <a-form-item> TODO expiration date -->
              <!--              <a-input placeholder="8 Digit Pin" addonBefore="$" />-->
              <!--            </a-form-item>-->
              <b-toast id="code-empty" variant="danger" title="Kortingscode">
                <i class="fe fe-alert-octagon mr-2" />Code kan niet leeg zijn
              </b-toast>
              <b-toast id="code-created" variant="primary" title="Kortingscode" >
                <i class="fe fe-plus-circle mr-2" />Code aangemaakt
              </b-toast>
              <b-toast id="something-went-wrong" variant="danger" title="Kortingscode">
                <i class="fe fe-alert-octagon mr-2" />Er ging iets fout
              </b-toast>
              <b-toast id="code-exists" variant="danger" title="Kortingscode" >
                <i class="fe fe-alert-octagon mr-2" />Code bestaat al
              </b-toast>
            </a-form>
          </a-modal>
      </a-tab-pane>
      <a-tab-pane tab="Kortingscodes" key="2">
        <div class="d-flex justify-content-start">
          <button
            type="button"
            class="btn btn-primary btn-with-addon mr-auto text-nowrap d-none d-md-block mb-3"
            @click="openCreateDiscountCodeModal()"
          >
          <span class="btn-addon">
            <i class="btn-addon-icon fe fe-plus-circle" />
          </span>
            Nieuwe Kortingscode
          </button>

          <a-modal
            id="modal-1"
            title="Kortingscode aanmaken"
            v-model="createDiscountCodeModal"
            @ok="createDiscountCode()"
          >
            <a-form layout="inline">
              <a-form-item Label="Kortingscode">
                <a-input placeholder="Code" v-model="newDiscountCode"/>
              </a-form-item>
              <!--            <a-form-item> TODO expiration date -->
              <!--              <a-input placeholder="8 Digit Pin" addonBefore="$" />-->
              <!--            </a-form-item>-->
              <b-toast id="code-empty" variant="danger" title="Kortingscode">
                <i class="fe fe-alert-octagon mr-2" />Code kan niet leeg zijn
              </b-toast>
              <b-toast id="code-created" variant="primary" title="Kortingscode" >
                <i class="fe fe-plus-circle mr-2" />Code aangemaakt
              </b-toast>
              <b-toast id="something-went-wrong" variant="danger" title="Kortingscode">
                <i class="fe fe-alert-octagon mr-2" />Er ging iets fout
              </b-toast>
              <b-toast id="code-exists" variant="danger" title="Kortingscode" >
                <i class="fe fe-alert-octagon mr-2" />Code bestaat al
              </b-toast>
            </a-form>
          </a-modal>
          <a-modal
            id="modal-1"
            title="Kortingscode aanpassen"
            v-model="updateDiscountCodeModal"
            @ok="updateDiscountCode()"
          >
            <a-form layout="inline">
              <a-form-item Label="Kortingscode">
                <a-input placeholder="Code" v-model="updatedDiscountCode"/>
              </a-form-item>
              <!--            <a-form-item> TODO expiration date -->
              <!--              <a-input placeholder="8 Digit Pin" addonBefore="$" />-->
              <!--            </a-form-item>-->
              <b-toast id="update-code-empty" variant="danger" title="Kortingscode">
                <i class="fe fe-alert-octagon mr-2" />Code kan niet leeg zijn
              </b-toast>
              <b-toast id="code-updated" variant="primary" title="Kortingscode" >
                <i class="fe fe-plus-circle mr-2" />Code aangepast
              </b-toast>
              <b-toast id="something-went-wrong" variant="danger" title="Kortingscode">
                <i class="fe fe-alert-octagon mr-2" />Er ging iets fout
              </b-toast>
              <b-toast id="code-exists" variant="danger" title="Kortingscode" >
                <i class="fe fe-alert-octagon mr-2" />Code bestaat al
              </b-toast>
            </a-form>
            <div v-if="discountCodeDiscountsLoading"  class="w-100 d-flex justify-content-center align-items-center">
              <a-spin size="large" />
            </div>
            <a-table
            v-else
              :columns="discountColumns"
              :dataSource="discountCodeDiscounts"
              :pagination="false"
              :rowKey='(data, i)=>{return `discountcodediscountsmodal-${i}`}'
            >
              <template slot="service_name" slot-scope="discount">
                <div>
                  <div>{{discount.services ? discount.services.name: 'Prijskorting'}}</div>
                </div>
              </template>
              <template slot="prijs" slot-scope="discount">
                <div>
                  <div>{{discount.discounted_rate !== "" ? '€ ':''}}<s>{{discount.services ? discount.services.rate : ""}}</s> {{discount.discounted_rate}}</div>
                </div>
              </template>
              <template slot="korting_hoeveelheid" slot-scope="discount">
                <div>
                  <div>{{discount.discount_type === 'rate'? `€${discount.discount_amount}`:`${discount.discount_amount}%`}}</div>
                </div>
              </template>
              <template slot="action" slot-scope="discount">
                <div>
                  <button type="button" v-if="discount.isEnabled" @click="toggleDiscountCodeDiscountsActive(selectedExistingDiscountCodeId, discount.id)" class="btn btn-danger">
                    <i class="fe fe-minus-circle" />
                  </button>
                  <button type="button" v-else @click="toggleDiscountCodeDiscountsActive(selectedExistingDiscountCodeId, discount.id)" class="btn btn-primary">
                    <i class="fe fe-plus-circle" />
                  </button>
                </div>
              </template>
            </a-table>
          </a-modal>
        </div>
        <div class="d-flex mb-3">
          <a-checkbox v-model="showInactiveDiscountCodes">Toon verwijderd</a-checkbox>
        </div>
        <div v-if="discountCodeLoading"  class="w-100 d-flex justify-content-center align-items-center">
          <a-spin size="large" />
        </div>

        <a-table
          v-else
          :columns="discountCodeColumns"
          :dataSource="discountCodes"
          :pagination="false"
          :rowKey='data=>{return `discountcodediscounts-${data.id}`}'
        >
          <div slot="expandedRowRender" slot-scope="data">
            <a-table
              :columns="discountColumns"
              :dataSource="data.discount"
              :pagination="false"
              :rowKey='(data, i)=>{return `discountcodediscountsnested-${i}`}'
            >
              <template slot="service_name" slot-scope="discount">
                <div>
                  <div>{{discount.services ? discount.services.name: 'Prijskorting'}}</div>
                </div>
              </template>
              <template slot="prijs" slot-scope="discount">
                <div>
                  <div>{{discount.discounted_rate !== "" ? '€ ':''}}<s>{{discount.services ? discount.services.rate : ""}}</s> {{discount.discounted_rate}}</div>
                </div>
              </template>
              <template slot="korting_hoeveelheid" slot-scope="discount">
                <div>
                  <div>{{discount.discount_type === 'rate'? `€${discount.discount_amount}`:`${discount.discount_amount}%`}}</div>
                </div>
              </template>
              <template slot="action" slot-scope="discount">
                <div>
                  <button type="button" @click="toggleDiscountCodeDiscountsActive(discount.pivot.discount_code_id, discount.id)" class="btn btn-danger">
                    <i class="fe fe-minus-circle" />
                  </button>
                </div>
              </template>
            </a-table>
          </div>
          <!--        <template slot="avatar" slot-scope="link">-->
          <!--          <div class="air__utils__avatar">-->
          <!--            <img :src="link" alt="User" />-->
          <!--          </div>-->
          <!--        </template>-->
          <template slot="code" slot-scope="data">
            <div v-bind:class="{ 'text-danger font-weight-bold': (data.deleted_at !== null) }">
              <div>{{data.code}}</div>
            </div>
          </template>
          <template slot="expires_at" slot-scope="data">
            <div>
              <div>{{data.expiration_date}}</div>
            </div>
          </template>
          <template slot="action" slot-scope="data">
            <div>
              <button @click="toggleDiscountCodeActive(data.id)" type="button" class="btn btn-danger mr-2">
                <i class="fe " v-bind:class="{ 'fe-toggle-left': (data.deleted_at !== null), 'fe-toggle-right': (data.deleted_at === null) }" />
              </button>
              <button type="button" @click="openUpdateDiscountCodeModal(data)" class="btn btn-light">
                <i class="fe fe-edit text-blue" />
              </button>
            </div>
          </template>
        </a-table>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
const discountColumns = [
  {
    title: 'Korting',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'service_name' },
  },
  {
    title: 'Prijs',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'prijs' },
  },
  {
    title: 'Korting Hoeveelheid',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'korting_hoeveelheid' },
  },
  {
    className: 'bg-transparent text-right',
    scopedSlots: { customRender: 'action' },
  },
]
const discountCodeColumns = [
  {
    title: 'Code',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'code' },
  },
  {
    title: 'Verloop Datum',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'expires_at' },
  },
  {
    className: 'bg-transparent text-right',
    scopedSlots: { customRender: 'action' },
  },
]
const discountCodeDiscountColumns = [
  {
    title: 'Code',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'code' },
  },
  {
    title: 'Prijs',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'prijs' },
  },
  {
    title: 'Korting Hoeveelheid',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'korting_hoeveelheid' },
  },
  {
    className: 'bg-transparent text-right',
    scopedSlots: { customRender: 'action' },
  },
]
const serviceColumns = [
  {
    title: 'Code',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'code' },
  },
  {
    title: 'Prijs',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'prijs' },
  },
  {
    title: 'Korting Hoeveelheid',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'korting_hoeveelheid' },
  },
  {
    className: 'bg-transparent text-right',
    scopedSlots: { customRender: 'action' },
  },
]
export default {
  name: 'DiscountList',
  computed: {
    user: {
      get: function () {
        return this.$store.state.user
      },
    },
  },
  data: function() {
    return {
      discountColumns,
      discountCodeColumns,
      discountCodeDiscountColumns,
      serviceColumns,
      discounts: [],
      discountCodes: [],
      createDiscountCodeModal: false,
      createDiscountModal: false,
      showInactiveDiscountCodes: false,
      updateDiscountCodeModal: false,
      updateDiscountModal: false,
      newDiscountCode: undefined,
      discountCodeLoading: true,
      discountCodeDiscountsLoading: true,
      discountLoading: true,
      updatedDiscountCode: undefined,
      selectedExistingDiscountCodeId: undefined,
      createDiscountDiscountType: 'rate',
      discountTypeLabel: 'Bedrag',
      newDiscountGlobal: false,
      newDiscountForService: false,
      newDiscountForServiceSelected: undefined,
      newDiscountForServiceSelectedId: false,
      newDiscountForServiceSelectedLabel: undefined,
      discountServicesListLoading: false,
      discountServicesList: [],
      newDiscountAmount: undefined,
      discountForService: undefined,
      selectedDiscountId: undefined,
    }
  },
  mounted() {
    this.getDiscounts()
  },
  watch: {
    showInactiveDiscountCodes: function (newQuestion, oldQuestion) {
      this.getDiscountCodes()
    },
  },
  methods: {
    toggleDiscountForService(toggle) {
      if (toggle.target.checked) {
        this.getServices()
      } else {
        this.newDiscountForServiceSelectedLabel = undefined
        this.newDiscountForServiceSelectedId = false
        this.newDiscountForServiceSelected = undefined
      }
      this.newDiscountForService = toggle.target.checked
    },
    getServices() {
      this.discountServicesListLoading = true
      this.$axios.get('/services/list', {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        } }).then(response => {
        this.discountServicesListLoading = false
        this.discountServicesList = response.data
      })
    },
    handleDiscountForServiceMenuClick(selectedService) {
      console.log(selectedService.key, this.discountServicesList.filter(service => { return service.id === parseInt(selectedService.key) })[0])
      this.newDiscountForServiceSelectedLabel = this.discountServicesList.filter(service => { return service.id === parseInt(selectedService.key) })[0]
      this.newDiscountForServiceSelectedId = selectedService.key
    },
    handleDiscountTypeMenuClick(discountType) {
      if (discountType.key === 'percentage') {
        this.discountTypeLabel = 'Percentage'
      }
      if (discountType.key === 'rate') {
        this.discountTypeLabel = 'Bedrag'
      }
      this.createDiscountDiscountType = discountType.key
    },
    tabSwitch(key) {
      switch (key) {
        case '1':
          this.getDiscounts()
          break
        case '2':
          this.getDiscountCodes()
          break
      }
    },
    openCreateDiscountCodeModal() {
      this.createDiscountCodeModal = true
    },
    openCreateDiscountModal() {
      this.selectedDiscountId = undefined
      this.newDiscountAmount = undefined
      this.newDiscountAmount = undefined
      this.createDiscountDiscountType = 'rate'
      this.discountTypeLabel = 'Bedrag'
      this.newDiscountForService = false
      this.newDiscountForServiceSelectedLabel = undefined
      this.newDiscountForServiceSelectedId = false
      this.newDiscountForServiceSelected = undefined
      this.newDiscountGlobal = false
      this.createDiscountModal = true
    },
    openUpdateDiscountModal(data) {
      this.selectedDiscountId = data.id
      this.newDiscountAmount = data.discount_amount
      this.createDiscountDiscountType = data.discount_type
      this.handleDiscountTypeMenuClick({ key: data.discount_type })
      if (data.service_id !== null) {
        this.getServices()
        // this.newDiscountForServiceSelectedLabel = this.discountServicesList.filter(service =>{return service.id === parseInt(data.service_id)})[0];
        this.newDiscountForServiceSelectedLabel = data.services
        this.newDiscountForServiceSelectedId = data.services.id
        this.newDiscountForServiceSelected = undefined
        this.newDiscountForService = true
      } else {
        this.newDiscountForServiceSelectedId = false
        this.newDiscountForServiceSelected = undefined
        this.newDiscountForServiceSelectedLabel = undefined
        this.newDiscountForService = false
      }

      this.newDiscountGlobal = data.global
      this.createDiscountModal = true
    },
    openUpdateDiscountCodeModal(data) {
      let { code, id } = data
      this.selectedExistingDiscountCodeId = id
      this.updatedDiscountCode = code
      this.getDiscountCodeDiscounts(id)
      this.updateDiscountCodeModal = true
    },
    toggleDiscountCodeActive(id) {
      this.$axios.post(`/discountcode/toggleActive`, {
        discount_code_id: id,
      }, {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        },
      }).then(response => {
        // this.discounts = response.data
        this.getDiscountCodes()
      })
    },
    updateDiscountCode() {
      if ((!this.selectedExistingDiscountCodeId || this.selectedExistingDiscountCodeId === '' || this.selectedExistingDiscountCodeId === undefined) && (!this.updatedDiscountCode || this.updatedDiscountCode === '' || this.updatedDiscountCode === undefined)) {
        this.$bvToast.show('update-code-empty', { toaster: 'b-toaster-top-right' })
        return true
      }
      this.$axios.post(`/discountcode/`, {
        discount_code_id: this.selectedExistingDiscountCodeId,
        code: this.updatedDiscountCode,
      }, {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        },
      }).then(response => {
        // this.discounts = response.data
        this.getDiscountCodes()
        this.selectedExistingDiscountCodeId = undefined
        this.updatedDiscountCode = undefined
        this.updateDiscountCodeModal = false
        this.$bvToast.show('code-updated', { toaster: 'b-toaster-top-right' })
      }).catch(error => {
        this.$bvToast.show('something-went-wrong', { toaster: 'b-toaster-top-right' })
        console.log(error)
      })
    },
    createDiscountCode() {
      if (!this.newDiscountCode || this.newDiscountCode === '' || this.newDiscountCode === undefined) {
        this.$bvToast.show('code-empty', { toaster: 'b-toaster-top-right' })
        console.log('tering')
        return true
      }
      this.$axios.post(`/discountcode`, {
        code: this.newDiscountCode,
      }, {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        },
      }).then(response => {
        // this.discounts = response.data
        this.getDiscountCodes()
        this.newDiscountCode = undefined
        this.createDiscountCodeModal = false
        this.$bvToast.show('code-created', { toaster: 'b-toaster-top-right' })
      }).catch(error => {
        if (error.response.status) {
          this.$bvToast.show('code-exists', { toaster: 'b-toaster-top-right' })
        } else {
          this.$bvToast.show('something-went-wrong', { toaster: 'b-toaster-top-right' })
        }
        console.log(error)
      })
    },
    createDiscount() {
      // if (!this.newDiscountCode || this.newDiscountCode === '' || this.newDiscountCode === undefined) {
      //   this.$bvToast.show('code-empty', { toaster: 'b-toaster-top-right' })
      //   console.log('tering')
      //   return true
      // }
      this.$axios.post(`/discounts`, {
        discount_id: this.selectedDiscountId ? this.selectedDiscountId : null,
        discount_amount: this.newDiscountAmount,
        discount_type: this.createDiscountDiscountType,
        service_id: (this.newDiscountForServiceSelectedId !== false) ? this.newDiscountForServiceSelectedId : null,
        global: this.newDiscountGlobal,
      }, {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        },
      }).then(response => {
        // this.discounts = response.data
        this.getDiscounts()
        this.newDiscountAmount = undefined
        this.newDiscountAmount = undefined
        this.createDiscountDiscountType = 'rate'
        this.discountTypeLabel = 'Bedrag'
        this.newDiscountForServiceSelectedLabel = undefined
        this.newDiscountForServiceSelectedId = false
        this.newDiscountForServiceSelected = undefined
        this.newDiscountGlobal = false
        this.createDiscountModal = false
        // this.$bvToast.show('code-created', { toaster: 'b-toaster-top-right' })
      }).catch(error => {
        this.$bvToast.show('something-went-wrong', { toaster: 'b-toaster-top-right' })
        console.log(error)
      })
    },
    getDiscounts() {
      this.discountLoading = true
      this.$axios.get(`/discounts`, {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        } }).then(response => {
        this.discountLoading = false
        this.discounts = response.data
      })
    },
    getDiscountCodes() {
      this.discountCodeLoading = true
      this.$axios.get(`/discountcodes`, {
        params: {
          inactive: this.showInactiveDiscountCodes,
        },
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        } }).then(response => {
        this.discountCodeLoading = false
        this.discountCodes = response.data
      })
    },
    toggleDiscountCodeDiscountsActive(discount_code_id, discount_id) {
      this.$axios.post(`/discountcodes/discounts/toggle`, {
        discount_code_id,
        discount_id,
      }, {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        },
      }).then(response => {
        // this.discounts = response.data
        this.getDiscountCodes()
        this.getDiscountCodeDiscounts(discount_code_id)
      })
    },
    getDiscountCodeDiscounts(discount_code_id) {
      this.discountCodeDiscountsLoading = true
      this.$axios.get(`/discountcodes/discounts`, {
        params: {
          discount_code_id,
        },
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        } }).then(response => {
        this.discountCodeDiscountsLoading = false
        this.discountCodeDiscounts = response.data
      })
    },
  },
}
</script>
